// Shipment-status labels (auto-merged by lib/i18n.ts). Shared by both surfaces.
export const en = {
  'status.booked': 'Booked',
  'status.in_transit': 'In Transit',
  'status.customs_hold': 'Customs Hold',
  'status.delayed': 'Delayed',
  'status.delivered': 'Delivered',
}

export const zhTW = {
  'status.booked': '已預訂',
  'status.in_transit': '運送中',
  'status.customs_hold': '海關扣留',
  'status.delayed': '延誤',
  'status.delivered': '已送達',
}
